import { render, staticRenderFns } from "./sumbit.vue?vue&type=template&id=496c9749&scoped=true&"
import script from "./sumbit.vue?vue&type=script&lang=js&"
export * from "./sumbit.vue?vue&type=script&lang=js&"
import style0 from "./sumbit.vue?vue&type=style&index=0&id=496c9749&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c9749",
  null
  
)

export default component.exports